/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_Version_HintInputs */



/**
* | output |
* | --- |
* | "An exact version such as 1.2.0 — ranges are refused. file:<path> runs a locally built package." |
*
* @param {Partner_Connectors_Field_Version_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_version_hint = /** @type {((inputs?: Partner_Connectors_Field_Version_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_Version_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Eine exakte Version wie 1.2.0 – Bereiche werden abgelehnt. file:<Pfad> führt ein lokal gebautes Paket aus.")
	return /** @type {LocalizedString} */ ("An exact version such as 1.2.0 — ranges are refused. file:<path> runs a locally built package.")
});